"use client"

import { useUser } from "@auth0/nextjs-auth0/client"
import mixpanel from "mixpanel-browser"
import { useEffect } from "react"

export function Tracked() {
    const { user } = useUser()

    useEffect(() => {
        mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN ?? "c56e94e481c20c32604ce76851254a6d", {
            track_pageview: true,
            persistence: "localStorage",
        })
    }, [])

    useEffect(() => {
        if (user && user.sub) {
            mixpanel.identify(user.sub)
        }
    }, [user])

    return <></>
}
